const MENU_DISABLED_TICKETS_TABLE_READY = "menu-disabled-tickets-table-ready"
const SEARCH_TEXT_STATE = "menu-disabled-tickets-table-search-text-state"
const ROWS_PER_PAGE_STATE = "menu-disabled-tickets-table-rows-per-page-state"
const PAGINATION_STATE = "menu-disabled-tickets-table-pagination-state"

const MENU_DISABLED_TICKETS_ID_FOR_ACTION = "menu-disabled-tickets-table-brand-id-for-action"

const MENU_DISABLED_TICKETS_UPDATE_READY = "add-edit-menu-disabled-tickets-ready"


const PREVIOUS_MENU_TICKETS_FILTER_START_DATE = "menu-disabled-tickets-previous-start-date"
const PREVIOUS_MENU_TICKETS_FILTER_END_DATE = "menu-disabled-tickets-previous-end-date"
const PREVIOUS_MENU_TICKETS_FILTER_CITY = "menu-disabled-tickets-previous-city"
const PREVIOUS_MENU_TICKETS_FILTER_KITCHEN = "menu-disabled-tickets-previous-kitchen"
const PREVIOUS_MENU_TICKETS_FILTER_STORE = "menu-disabled-tickets-previous-store"
const PREVIOUS_MENU_TICKETS_FILTER_STATUS = "menu-disabled-tickets-previous-status"
const PREVIOUS_MENU_TICKETS_FILTER_PLATFORM = "menu-disabled-tickets-previous-platform"

const initialState = {
    isMenuDisabledTicketsTableReady: true,
    isMenuDisabledTicketUpdateReady:true,
    menuDisabledTickets: {},

   
    previousFilterStartDate: "",
    previousFilterEndDate: "",
    previousFilterCity: "",
    previousFilterStatus: "",
    previousFilterKitchen: "",
    previousFilterStore: "",
    previousFilterPlatform: "",
    
    storeSelectedId: null,
    
    menuDisabledTicketsSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case MENU_DISABLED_TICKETS_TABLE_READY:
            return Object.assign({}, state, { isMenuDisabledTicketsTableReady: action.payload })
        case MENU_DISABLED_TICKETS_UPDATE_READY:
            return Object.assign({}, state, { isMenuDisabledTicketUpdateReady: action.payload })
        


        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case MENU_DISABLED_TICKETS_ID_FOR_ACTION:
            return Object.assign({}, state, {menuDisabledTicketsSelectedId:action.payload})




        case PREVIOUS_MENU_TICKETS_FILTER_START_DATE:
            return Object.assign({}, state, {previousFilterStartDate:action.payload})
        case PREVIOUS_MENU_TICKETS_FILTER_END_DATE:
            return Object.assign({}, state, {previousFilterEndDate:action.payload})
        case PREVIOUS_MENU_TICKETS_FILTER_CITY:
            return Object.assign({}, state, {previousFilterCity:action.payload})
        case PREVIOUS_MENU_TICKETS_FILTER_STATUS:
            return Object.assign({}, state, {previousFilterStatus:action.payload})
        case PREVIOUS_MENU_TICKETS_FILTER_KITCHEN:
            return Object.assign({}, state, {previousFilterKitchen:action.payload})
            
        case PREVIOUS_MENU_TICKETS_FILTER_STORE:
            return Object.assign({}, state, {previousFilterStore:action.payload})
        case PREVIOUS_MENU_TICKETS_FILTER_PLATFORM:
            return Object.assign({}, state, {previousFilterPlatform:action.payload})


        default:
        return state
    
    }

}

export function menuDisabledTicketsTableReady(data) {
    return {
        type: MENU_DISABLED_TICKETS_TABLE_READY,
        payload: data
    }
}


export function menuDisabledTicketUpdateReady(data) {
    return {
        type: MENU_DISABLED_TICKETS_UPDATE_READY,
        payload: data
    }
}



export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function menuDisabledTicketsIdForAction(brandId){
    return{
        type:MENU_DISABLED_TICKETS_ID_FOR_ACTION,
        payload:brandId
    }
}



export function previousFilterStartDate(fiter_val){
    return{
        type:PREVIOUS_MENU_TICKETS_FILTER_START_DATE,
        payload:fiter_val
    }
}


export function previousFilterEndDate(fiter_val){
    return{
        type:PREVIOUS_MENU_TICKETS_FILTER_END_DATE,
        payload:fiter_val
    }
}



export function previousFilterCity(fiter_val){
    return{
        type:PREVIOUS_MENU_TICKETS_FILTER_CITY,
        payload:fiter_val
    }
}


export function previousFilterStatus(fiter_val){
    return{
        type:PREVIOUS_MENU_TICKETS_FILTER_STATUS,
        payload:fiter_val
    }
}


export function previousFilterKitchen(fiter_val){
    return{
        type:PREVIOUS_MENU_TICKETS_FILTER_KITCHEN,
        payload:fiter_val
    }
}




export function previousFilterStore(fiter_val){
    return{
        type:PREVIOUS_MENU_TICKETS_FILTER_STORE,
        payload:fiter_val
    }
}

export function previousFilterPlatform(fiter_val){
    return{
        type:PREVIOUS_MENU_TICKETS_FILTER_PLATFORM,
        payload:fiter_val
    }
}



// WEBPACK FOOTER //
// ./src/modules/Menu Disabled Tickets/redux/menu_disabled_tickets.js